import React from "react";

const MarketDesktopTabs = ({
  activeTab,
  setActiveTab,
  searchQuery,
  setSearchQuery,
  handleSearch,
  setShowFilters,
}) => {
  return (
    <div className="flex justify-between items-center px-14 py-4">
      <div className="flex gap-2">
        <button
          onClick={() => setActiveTab("all")}
          className={`px-4 py-2 rounded-lg text-[16px] transition-colors ${
            activeTab === "all"
              ? "bg-[#F3F4F6] text-[#0B0B0B]"
              : "text-[#1E1E1ECC]"
          }`}
        >
          All
        </button>
        <button
          onClick={() => setActiveTab("for-sale")}
          className={`px-4 py-2 rounded-lg text-[16px] transition-colors ${
            activeTab === "for-sale"
              ? "bg-[#F3F4F6] text-[#0B0B0B]"
              : "text-[#1E1E1ECC]"
          }`}
        >
          For Sale
        </button>
        <button
          onClick={() => setActiveTab("for-loan")}
          className={`px-4 py-2 rounded-lg text-[16px] transition-colors ${
            activeTab === "for-loan"
              ? "bg-[#F3F4F6] text-[#0B0B0B]"
              : "text-[#1E1E1ECC]"
          }`}
        >
          For loan
        </button>
      </div>

      <div className="flex gap-4 items-center">
        {/* Search Input - Always Visible */}
        <div className="relative">
          <input
            type="text"
            placeholder="Search players..."
            className="w-64 px-4 py-2 border border-[#D2D4D8] rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
          <button
            onClick={handleSearch}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600"
          >
            <svg
              className="w-4 h-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </button>
        </div>

        {/* Filters Button */}
        <button
          onClick={() => setShowFilters(true)}
          className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-sm text-[#1E1E1E] hover:bg-gray-50 transition-colors"
        >
          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
            />
          </svg>
          Filters
        </button>
      </div>
    </div>
  );
};

export default MarketDesktopTabs;
